// カートをロードし (カート ページへのリダイレクトを回避)、制限変数がロードされるのを待ちます
var elems = document.getElementById('cart-icon-bubble');
elems.style.display = 'block';
// function whenAvailable(name, callback) {
//   var interval = 2000; // ms
//   window.setTimeout(function() {
//       if (window[name]) {
//         elems.style.display = "block";
//           callback(window[name]);
//       } else {
//           whenAvailable(name, callback);
//       }
//   }, interval);
// }
!(function (t, e) {
  'object' === typeof exports && 'object' === typeof module
    ? (module.exports = e())
    : 'function' === typeof define && define.amd
      ? define('GoCart', [], e)
      : 'object' === typeof exports
        ? (exports.GoCart = e())
        : (t.GoCart = e());
})(window, function () {
  return (function (t) {
    var e = {};
    function __webpack_require__(r) {
      if (e[r]) return e[r].exports;
      var a = (e[r] = {i: r, l: !1, exports: {}});
      return t[r].call(a.exports, a, a.exports, __webpack_require__), (a.l = !0), a.exports;
    }
    return (
      (__webpack_require__.m = t),
      (__webpack_require__.c = e),
      (__webpack_require__.d = function (t, e, r) {
        __webpack_require__.o(t, e) || Object.defineProperty(t, e, {enumerable: !0, get: r});
      }),
      (__webpack_require__.r = function (t) {
        'undefined' !== typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, {value: 'Module'}),
          Object.defineProperty(t, '__esModule', {value: !0});
      }),
      (__webpack_require__.t = function (t, e) {
        if ((1 & e && (t = __webpack_require__(t)), 8 & e)) return t;
        if (4 & e && 'object' === typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (
          (__webpack_require__.r(r),
          Object.defineProperty(r, 'default', {enumerable: !0, value: t}),
          2 & e && 'string' != typeof t)
        )
          for (var a in t)
            __webpack_require__.d(
              r,
              a,
              function (e) {
                return t[e];
              }.bind(null, a)
            );
        return r;
      }),
      (__webpack_require__.n = function (t) {
        var e =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return __webpack_require__.d(e, 'a', e), e;
      }),
      (__webpack_require__.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (__webpack_require__.p = ''),
      __webpack_require__((__webpack_require__.s = 1))
    );
  })([
    function (t, e, r) {
      var a = r(3),
        o = /^(?:submit|button|image|reset|file)$/i,
        n = /^(?:input|select|textarea|keygen)/i,
        i = /(\[[^\[\]]*\])/g;
      function hash_serializer(t, e, r) {
        if (e.match(i)) {
          !(function hash_assign(t, e, r) {
            if (0 === e.length) return (t = r);
            var a = e.shift(),
              o = a.match(/^\[(.+?)\]$/);
            if ('[]' === a)
              return (
                (t = t || []),
                Array.isArray(t)
                  ? t.push(hash_assign(null, e, r))
                  : ((t._values = t._values || []), t._values.push(hash_assign(null, e, r))),
                t
              );
            if (o) {
              var n = o[1],
                i = +n;
              isNaN(i) ? ((t = t || {})[n] = hash_assign(t[n], e, r)) : ((t = t || [])[i] = hash_assign(t[i], e, r));
            } else t[a] = hash_assign(t[a], e, r);
            return t;
          })(
            t,
            (function (t) {
              var e = [],
                r = new RegExp(i),
                a = /^([^\[\]]*)/.exec(t);
              for (a[1] && e.push(a[1]); null !== (a = r.exec(t)); ) e.push(a[1]);
              return e;
            })(e),
            r
          );
        } else {
          var a = t[e];
          a ? (Array.isArray(a) || (t[e] = [a]), t[e].push(r)) : (t[e] = r);
        }
        return t;
      }
      function str_serialize(t, e, r) {
        return (
          (r = r.replace(/(\r)?\n/g, '\r\n')),
          (r = (r = encodeURIComponent(r)).replace(/%20/g, '+')),
          t + (t ? '&' : '') + encodeURIComponent(e) + '=' + r
        );
      }
      t.exports = function (t, e) {
        'object' != a(e) ? (e = {hash: !!e}) : void 0 === e.hash && (e.hash = !0);
        for (
          var r = e.hash ? {} : '',
            i = e.serializer || (e.hash ? hash_serializer : str_serialize),
            s = t && t.elements ? t.elements : [],
            c = Object.create(null),
            l = 0;
          l < s.length;
          ++l
        ) {
          var u = s[l];
          if ((e.disabled || !u.disabled) && u.name && n.test(u.nodeName) && !o.test(u.type)) {
            var d = u.name,
              f = u.value;
            if ((('checkbox' !== u.type && 'radio' !== u.type) || u.checked || (f = void 0), e.empty)) {
              if (
                ('checkbox' !== u.type || u.checked || (f = ''),
                'radio' === u.type && (c[u.name] || u.checked ? u.checked && (c[u.name] = !0) : (c[u.name] = !1)),
                void 0 == f && 'radio' == u.type)
              )
                continue;
            } else if (!f) continue;
            if ('select-multiple' !== u.type) r = i(r, d, f);
            else {
              f = [];
              for (var h = u.options, y = !1, p = 0; p < h.length; ++p) {
                var m = h[p],
                  b = e.empty && !m.value,
                  v = m.value || b;
                m.selected &&
                  v &&
                  ((y = !0),
                  (r = e.hash && '[]' !== d.slice(d.length - 2) ? i(r, d + '[]', m.value) : i(r, d, m.value)));
              }
              !y && e.empty && (r = i(r, d, ''));
            }
          }
        }
        if (e.empty) for (var d in c) c[d] || (r = i(r, d, ''));
        return r;
      };
    },
    function (t, e, r) {
      t.exports = r(4);
    },
    function (t, e, r) {},
    function (t, e) {
      function _typeof2(t) {
        return (_typeof2 =
          'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t && 'function' === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                  ? 'symbol'
                  : typeof t;
              })(t);
      }
      function _typeof(e) {
        return (
          'function' === typeof Symbol && 'symbol' === _typeof2(Symbol.iterator)
            ? (t.exports = _typeof =
                function (t) {
                  return _typeof2(t);
                })
            : (t.exports = _typeof =
                function (t) {
                  return t && 'function' === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                    ? 'symbol'
                    : _typeof2(t);
                }),
          _typeof(e)
        );
      }
      t.exports = _typeof;
    },
    function (t, e, r) {
      'use strict';
      r.r(e);
      r(2);
      var a = '{{amount}}';
      function formatMoney(t, e) {
        'string' === typeof t && (t = t.replace('.00', ''));
        var r = '',
          o = /\{\{\s*(\w+)\s*\}\}/,
          n = e || a;
        function formatWithDelimiters(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ',',
            a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : '.';
          if (isNaN(t) || null == t) return 0;
          var o = (t = (t / 100).toFixed(e)).split('.');
          return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1'.concat(r)) + (o[1] ? a + o[1] : '');
        }
        switch (n.match(o)[1]) {
          case 'amount':
            r = formatWithDelimiters(t, 2);
            break;
          case 'amount_no_decimals':
            r = formatWithDelimiters(t, 0);
            break;
          case 'amount_with_comma_separator':
            r = formatWithDelimiters(t, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            r = formatWithDelimiters(t, 0, '.', ',');
        }
        return n.replace(o, r);
      }
      function _typeof(t) {
        return (_typeof =
          'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t && 'function' === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                  ? 'symbol'
                  : typeof t;
              })(t);
      }
      var o =
          ('undefined' !== typeof globalThis && globalThis) ||
          ('undefined' !== typeof self && self) ||
          ('undefined' !== typeof o && o),
        n = {
          searchParams: 'URLSearchParams' in o,
          iterable: 'Symbol' in o && 'iterator' in Symbol,
          blob:
            'FileReader' in o &&
            'Blob' in o &&
            (function () {
              try {
                return new Blob(), !0;
              } catch (t) {
                return !1;
              }
            })(),
          formData: 'FormData' in o,
          arrayBuffer: 'ArrayBuffer' in o,
        };
      if (n.arrayBuffer)
        var i = [
            '[object Int8Array]',
            '[object Uint8Array]',
            '[object Uint8ClampedArray]',
            '[object Int16Array]',
            '[object Uint16Array]',
            '[object Int32Array]',
            '[object Uint32Array]',
            '[object Float32Array]',
            '[object Float64Array]',
          ],
          s =
            ArrayBuffer.isView ||
            function (t) {
              return t && i.indexOf(Object.prototype.toString.call(t)) > -1;
            };
      function normalizeName(t) {
        if (('string' !== typeof t && (t = String(t)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(t) || '' === t))
          throw new TypeError('Invalid character in header field name');
        return t.toLowerCase();
      }
      function normalizeValue(t) {
        return 'string' !== typeof t && (t = String(t)), t;
      }
      function iteratorFor(t) {
        var e = {
          next: function () {
            var e = t.shift();
            return {done: void 0 === e, value: e};
          },
        };
        return (
          n.iterable &&
            (e[Symbol.iterator] = function () {
              return e;
            }),
          e
        );
      }
      function Headers(t) {
        (this.map = {}),
          t instanceof Headers
            ? t.forEach(function (t, e) {
                this.append(e, t);
              }, this)
            : Array.isArray(t)
              ? t.forEach(function (t) {
                  this.append(t[0], t[1]);
                }, this)
              : t &&
                Object.getOwnPropertyNames(t).forEach(function (e) {
                  this.append(e, t[e]);
                }, this);
      }
      function consumed(t) {
        if (t.bodyUsed) return Promise.reject(new TypeError('Already read'));
        t.bodyUsed = !0;
      }
      function fileReaderReady(t) {
        return new Promise(function (e, r) {
          (t.onload = function () {
            e(t.result);
          }),
            (t.onerror = function () {
              r(t.error);
            });
        });
      }
      function readBlobAsArrayBuffer(t) {
        var e = new FileReader(),
          r = fileReaderReady(e);
        return e.readAsArrayBuffer(t), r;
      }
      function bufferClone(t) {
        if (t.slice) return t.slice(0);
        var e = new Uint8Array(t.byteLength);
        return e.set(new Uint8Array(t)), e.buffer;
      }
      function Body() {
        return (
          (this.bodyUsed = !1),
          (this._initBody = function (t) {
            var e;
            (this.bodyUsed = this.bodyUsed),
              (this._bodyInit = t),
              t
                ? 'string' === typeof t
                  ? (this._bodyText = t)
                  : n.blob && Blob.prototype.isPrototypeOf(t)
                    ? (this._bodyBlob = t)
                    : n.formData && FormData.prototype.isPrototypeOf(t)
                      ? (this._bodyFormData = t)
                      : n.searchParams && URLSearchParams.prototype.isPrototypeOf(t)
                        ? (this._bodyText = t.toString())
                        : n.arrayBuffer && n.blob && (e = t) && DataView.prototype.isPrototypeOf(e)
                          ? ((this._bodyArrayBuffer = bufferClone(t.buffer)),
                            (this._bodyInit = new Blob([this._bodyArrayBuffer])))
                          : n.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(t) || s(t))
                            ? (this._bodyArrayBuffer = bufferClone(t))
                            : (this._bodyText = t = Object.prototype.toString.call(t))
                : (this._bodyText = ''),
              this.headers.get('content-type') ||
                ('string' === typeof t
                  ? this.headers.set('content-type', 'text/plain;charset=UTF-8')
                  : this._bodyBlob && this._bodyBlob.type
                    ? this.headers.set('content-type', this._bodyBlob.type)
                    : n.searchParams &&
                      URLSearchParams.prototype.isPrototypeOf(t) &&
                      this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8'));
          }),
          n.blob &&
            ((this.blob = function () {
              var t = consumed(this);
              if (t) return t;
              if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
              if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
              if (this._bodyFormData) throw new Error('could not read FormData body as blob');
              return Promise.resolve(new Blob([this._bodyText]));
            }),
            (this.arrayBuffer = function () {
              if (this._bodyArrayBuffer) {
                var t = consumed(this);
                return (
                  t ||
                  (ArrayBuffer.isView(this._bodyArrayBuffer)
                    ? Promise.resolve(
                        this._bodyArrayBuffer.buffer.slice(
                          this._bodyArrayBuffer.byteOffset,
                          this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                        )
                      )
                    : Promise.resolve(this._bodyArrayBuffer))
                );
              }
              return this.blob().then(readBlobAsArrayBuffer);
            })),
          (this.text = function () {
            var t = consumed(this);
            if (t) return t;
            if (this._bodyBlob)
              return (function (t) {
                var e = new FileReader(),
                  r = fileReaderReady(e);
                return e.readAsText(t), r;
              })(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(
                (function (t) {
                  for (var e = new Uint8Array(t), r = new Array(e.length), a = 0; a < e.length; a++)
                    r[a] = String.fromCharCode(e[a]);
                  return r.join('');
                })(this._bodyArrayBuffer)
              );
            if (this._bodyFormData) throw new Error('could not read FormData body as text');
            return Promise.resolve(this._bodyText);
          }),
          n.formData &&
            (this.formData = function () {
              return this.text().then(decode);
            }),
          (this.json = function () {
            return this.text().then(JSON.parse);
          }),
          this
        );
      }
      (Headers.prototype.append = function (t, e) {
        (t = normalizeName(t)), (e = normalizeValue(e));
        var r = this.map[t];
        this.map[t] = r ? r + ', ' + e : e;
      }),
        (Headers.prototype.delete = function (t) {
          delete this.map[normalizeName(t)];
        }),
        (Headers.prototype.get = function (t) {
          return (t = normalizeName(t)), this.has(t) ? this.map[t] : null;
        }),
        (Headers.prototype.has = function (t) {
          return this.map.hasOwnProperty(normalizeName(t));
        }),
        (Headers.prototype.set = function (t, e) {
          this.map[normalizeName(t)] = normalizeValue(e);
        }),
        (Headers.prototype.forEach = function (t, e) {
          for (var r in this.map) this.map.hasOwnProperty(r) && t.call(e, this.map[r], r, this);
        }),
        (Headers.prototype.keys = function () {
          var t = [];
          return (
            this.forEach(function (e, r) {
              t.push(r);
            }),
            iteratorFor(t)
          );
        }),
        (Headers.prototype.values = function () {
          var t = [];
          return (
            this.forEach(function (e) {
              t.push(e);
            }),
            iteratorFor(t)
          );
        }),
        (Headers.prototype.entries = function () {
          var t = [];
          return (
            this.forEach(function (e, r) {
              t.push([r, e]);
            }),
            iteratorFor(t)
          );
        }),
        n.iterable && (Headers.prototype[Symbol.iterator] = Headers.prototype.entries);
      var c = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
      function Request(t, e) {
        if (!(this instanceof Request))
          throw new TypeError(
            'Please use the "new" operator, this DOM object constructor cannot be called as a function.'
          );
        var r = (e = e || {}).body;
        if (t instanceof Request) {
          if (t.bodyUsed) throw new TypeError('Already read');
          (this.url = t.url),
            (this.credentials = t.credentials),
            e.headers || (this.headers = new Headers(t.headers)),
            (this.method = t.method),
            (this.mode = t.mode),
            (this.signal = t.signal),
            r || null == t._bodyInit || ((r = t._bodyInit), (t.bodyUsed = !0));
        } else this.url = String(t);
        if (
          ((this.credentials = e.credentials || this.credentials || 'same-origin'),
          (!e.headers && this.headers) || (this.headers = new Headers(e.headers)),
          (this.method = (function (t) {
            var e = t.toUpperCase();
            return c.indexOf(e) > -1 ? e : t;
          })(e.method || this.method || 'GET')),
          (this.mode = e.mode || this.mode || null),
          (this.signal = e.signal || this.signal),
          (this.referrer = null),
          ('GET' === this.method || 'HEAD' === this.method) && r)
        )
          throw new TypeError('Body not allowed for GET or HEAD requests');
        if (
          (this._initBody(r),
          ('GET' === this.method || 'HEAD' === this.method) && ('no-store' === e.cache || 'no-cache' === e.cache))
        ) {
          var a = /([?&])_=[^&]*/;
          if (a.test(this.url)) this.url = this.url.replace(a, '$1_=' + new Date().getTime());
          else {
            this.url += (/\?/.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
          }
        }
      }
      function decode(t) {
        var e = new FormData();
        return (
          t
            .trim()
            .split('&')
            .forEach(function (t) {
              if (t) {
                var r = t.split('='),
                  a = r.shift().replace(/\+/g, ' '),
                  o = r.join('=').replace(/\+/g, ' ');
                e.append(decodeURIComponent(a), decodeURIComponent(o));
              }
            }),
          e
        );
      }
      function parseHeaders(t) {
        var e = new Headers();
        return (
          t
            .replace(/\r?\n[\t ]+/g, ' ')
            .split(/\r?\n/)
            .forEach(function (t) {
              var r = t.split(':'),
                a = r.shift().trim();
              if (a) {
                var o = r.join(':').trim();
                e.append(a, o);
              }
            }),
          e
        );
      }
      function Response(t, e) {
        if (!(this instanceof Response))
          throw new TypeError(
            'Please use the "new" operator, this DOM object constructor cannot be called as a function.'
          );
        e || (e = {}),
          (this.type = 'default'),
          (this.status = void 0 === e.status ? 200 : e.status),
          (this.ok = this.status >= 200 && this.status < 300),
          (this.statusText = 'statusText' in e ? e.statusText : ''),
          (this.headers = new Headers(e.headers)),
          (this.url = e.url || ''),
          this._initBody(t);
      }
      (Request.prototype.clone = function () {
        return new Request(this, {body: this._bodyInit});
      }),
        Body.call(Request.prototype),
        Body.call(Response.prototype),
        (Response.prototype.clone = function () {
          return new Response(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers(this.headers),
            url: this.url,
          });
        }),
        (Response.error = function () {
          var t = new Response(null, {status: 0, statusText: ''});
          return (t.type = 'error'), t;
        });
      var l = [301, 302, 303, 307, 308];
      Response.redirect = function (t, e) {
        if (-1 === l.indexOf(e)) throw new RangeError('Invalid status code');
        return new Response(null, {status: e, headers: {location: t}});
      };
      var u = o.DOMException;
      try {
        new u();
      } catch (y) {
        ((u = function (t, e) {
          (this.message = t), (this.name = e);
          var r = Error(t);
          this.stack = r.stack;
        }).prototype = Object.create(Error.prototype)),
          (u.prototype.constructor = u);
      }
      function fetch(t, e) {
        return new Promise(function (r, a) {
          var i = new Request(t, e);
          if (i.signal && i.signal.aborted) return a(new u('Aborted', 'AbortError'));
          var s = new XMLHttpRequest();
          function abortXhr() {
            s.abort();
          }
          (s.onload = function () {
            var t = {
              status: s.status,
              statusText: s.statusText,
              headers: parseHeaders(s.getAllResponseHeaders() || ''),
            };
            t.url = 'responseURL' in s ? s.responseURL : t.headers.get('X-Request-URL');
            var e = 'response' in s ? s.response : s.responseText;
            setTimeout(function () {
              r(new Response(e, t));
            }, 0);
          }),
            (s.onerror = function () {
              setTimeout(function () {
                a(new TypeError('Network request failed'));
              }, 0);
            }),
            (s.ontimeout = function () {
              setTimeout(function () {
                a(new TypeError('Network request failed'));
              }, 0);
            }),
            (s.onabort = function () {
              setTimeout(function () {
                a(new u('Aborted', 'AbortError'));
              }, 0);
            }),
            s.open(
              i.method,
              (function (t) {
                try {
                  return '' === t && o.location.href ? o.location.href : t;
                } catch (e) {
                  return t;
                }
              })(i.url),
              !0
            ),
            'include' === i.credentials
              ? (s.withCredentials = !0)
              : 'omit' === i.credentials && (s.withCredentials = !1),
            'responseType' in s &&
              (n.blob
                ? (s.responseType = 'blob')
                : n.arrayBuffer &&
                  i.headers.get('Content-Type') &&
                  -1 !== i.headers.get('Content-Type').indexOf('application/octet-stream') &&
                  (s.responseType = 'arraybuffer')),
            !e || 'object' !== _typeof(e.headers) || e.headers instanceof Headers
              ? i.headers.forEach(function (t, e) {
                  s.setRequestHeader(e, t);
                })
              : Object.getOwnPropertyNames(e.headers).forEach(function (t) {
                  s.setRequestHeader(t, normalizeValue(e.headers[t]));
                }),
            i.signal &&
              (i.signal.addEventListener('abort', abortXhr),
              (s.onreadystatechange = function () {
                4 === s.readyState && i.signal.removeEventListener('abort', abortXhr);
              })),
            s.send('undefined' === typeof i._bodyInit ? null : i._bodyInit);
        });
      }
      (fetch.polyfill = !0),
        o.fetch || ((o.fetch = fetch), (o.Headers = Headers), (o.Request = Request), (o.Response = Response));
      var d = r(0),
        f = r.n(d);
      function _defineProperties(t, e) {
        for (var r = 0; r < e.length; r++) {
          var a = e[r];
          (a.enumerable = a.enumerable || !1),
            (a.configurable = !0),
            'value' in a && (a.writable = !0),
            Object.defineProperty(t, a.key, a);
        }
      }
      var h = (function () {
        function GoCart(t) {
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
          })(this, GoCart);
          (this.defaults = Object.assign(
            {},
            {
              cartModalFail: '.js-go-cart-modal-fail',
              cartModalFailClose: '.js-go-cart-modal-fail-close',
              cartModal: '.js-go-cart-modal',
              cartModalClose: '.js-go-cart-modal-close',
              cartModalContent: '.js-go-cart-modal-content',
              cartDrawer: '.js-go-cart-drawer',
              cartDrawerContent: '.js-go-cart-drawer-content',
              cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
              cartDrawerFooter: '.js-go-cart-drawer-footer',
              cartDrawerClose: '.js-go-cart-drawer-close',
              cartMiniCart: '.js-go-cart-mini-cart',
              cartMiniCartContent: '.js-go-cart-mini-cart-content',
              cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
              cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
              cartTrigger: '.js-go-cart-trigger',
              cartOverlay: '.js-go-cart-overlay',
              cartCount: '.js-go-cart-counter',
              addToCart: '.js-go-cart-add-to-cart',
              removeFromCart: '.js-go-cart-remove-from-cart',
              removeFromCartNoDot: 'js-go-cart-remove-from-cart',
              itemQuantity: '.js-go-cart-quantity',
              itemQuantityPlus: '.js-go-cart-quantity-plus',
              itemQuantityMinus: '.js-go-cart-quantity-minus',
              cartMode: 'drawer',
              drawerDirection: '',
              displayModal: !1,
              moneyFormat: '{{amount}}',
              labelCartIsEmpty: 'カートに商品がありません',
              labelQuantity: 'Quantity:',
              labelRemove: '削除',
            },
            t
          )),
            (this.cartModalFail = document.querySelector(this.defaults.cartModalFail)),
            (this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose)),
            (this.cartModal = document.querySelector(this.defaults.cartModal)),
            (this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose)),
            (this.cartModalContent = document.querySelector(this.defaults.cartModalContent)),
            (this.cartDrawer = document.querySelector(this.defaults.cartDrawer)),
            (this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent)),
            (this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal)),
            (this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter)),
            (this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose)),
            (this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart)),
            (this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent)),
            (this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal)),
            (this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter)),
            (this.cartTrigger = document.querySelector(this.defaults.cartTrigger)),
            (this.cartOverlay = document.querySelector(this.defaults.cartOverlay)),
            (this.cartCount = document.querySelector(this.defaults.cartCount)),
            (this.addToCart = document.querySelectorAll(this.defaults.addToCart)),
            (this.removeFromCart = this.defaults.removeFromCart),
            (this.removeFromCartNoDot = this.defaults.removeFromCartNoDot),
            (this.itemQuantity = this.defaults.itemQuantity),
            (this.itemQuantityPlus = this.defaults.itemQuantityPlus),
            (this.itemQuantityMinus = this.defaults.itemQuantityMinus),
            (this.cartMode = this.defaults.cartMode),
            (this.drawerDirection = this.defaults.drawerDirection),
            (this.displayModal = this.defaults.displayModal),
            (this.moneyFormat = this.defaults.moneyFormat),
            (this.labelCartIsEmpty = this.defaults.labelCartIsEmpty),
            (this.labelQuantity = this.defaults.labelQuantity),
            (this.labelRemove = this.defaults.labelRemove),
            this.init();
        }

        // 購入制限チェック ： 「OrichiQuantityLimitResult」はアプリ側に用意してもらった関数
        // const limitChecker = (product, variant, quantity) => {
        //   // 購入制限の対象となっていない場合
        //   if (OrichiQuantityLimitResult.ListLimitProduct.length === 0) return false;
        //   // Product単位で購入制限
        //   if (OrichiQuantityLimitResult.ListLimitVariant.length === 0) {
        //     for (let index = 0; index < OrichiQuantityLimitResult.ListLimitProduct.length; index++) {
        //       if (OrichiQuantityLimitResult.ListLimitProduct[index].ProductID === product) {
        //         // ユーザー単位の購入制限の対象となった場合
        //         if (OrichiQuantityLimitResult.ListLimitProduct[index].MaxQuantity === OrichiQuantityLimitResult.ListLimitProduct[index].LifeTimeQuantity) return true;
        //         // 設定している上限数以上をカートインした場合
        //         if (OrichiQuantityLimitResult.ListLimitProduct[index].MaxQuantity <= OrichiQuantityLimitResult.ListLimitProduct[index].Quantity) {
        //           return (OrichiQuantityLimitResult.ListLimitProduct[index].MaxQuantity <= OrichiQuantityLimitResult.ListLimitProduct[index].Quantity);
        //         }
        //         // 設定している下限数以下がカートインされている場合
        //         if (OrichiQuantityLimitResult.ListLimitProduct[index].MinQuantity > OrichiQuantityLimitResult.ListLimitProduct[index].Quantity) {
        //           const minLimitText = document.querySelectorAll('.min-limit-text');
        //           if (minLimitText) {
        //             minLimitText.forEach((elem) => {
        //               const productId = elem.closest('.c-list__item').getAttribute('data-product');
        //               if (productId === String(OrichiQuantityLimitResult.ListLimitProduct[index].ProductID)) {
        //                 elem.textContent = `${OrichiQuantityLimitResult.ListLimitProduct[index].MinQuantity}点以上で購入可能です。`;
        //               }
        //             });
        //           }
        //         }
        //       }
        //     }
        //   }
        //   // Variant単位で購入制限
        //   if (OrichiQuantityLimitResult.ListLimitVariant.length) {
        //     for (let index = 0; index < OrichiQuantityLimitResult.ListLimitVariant.length ; index++) {
        //       if (OrichiQuantityLimitResult.ListLimitVariant[index].VariantID === variant) {
        //         // ユーザー単位の購入制限の対象となった場合
        //         if (OrichiQuantityLimitResult.ListLimitVariant[index].Max === OrichiQuantityLimitResult.ListLimitVariant[index].QuantityVariantLifeTime) return true;
        //         // 設定している上限数以上をカートインした場合
        //         if (OrichiQuantityLimitResult.ListLimitVariant[index].Max <= quantity) {
        //           const variantLimit = () => {
        //             const modalContentList = document.querySelector('.c-modal__content-list');
        //             if (modalContentList) {
        //               const productId = modalContentList.getAttribute('cart-product-id');
        //               if (productId === String(OrichiQuantityLimitResult.ListLimitVariant[index].ProductID)) {
        //                 modalContentList.classList.add('limit-variant');
        //               }
        //             }
        //             return true;
        //           }
        //           return variantLimit();
        //         } else if (OrichiQuantityLimitResult.ListLimitVariant[index].Min > quantity) {
        //           // 設定している下限数以下がカートインされている場合
        //           const minLimitText = document.querySelectorAll('.min-limit-text');
        //           if (minLimitText) {
        //             minLimitText.forEach((elem) => {
        //               const variantId = elem.closest('.c-list__item').getAttribute('data-var');
        //               if (variantId === String(OrichiQuantityLimitResult.ListLimitVariant[index].VariantID)) {
        //                 elem.textContent = `${OrichiQuantityLimitResult.ListLimitVariant[index].Min}点以上で購入可能です。`;
        //               }
        //             });
        //           }
        //         } else {
        //           return false;
        //         }
        //       }
        //     }
        //     for (let index = 0; index < OrichiQuantityLimitResult.ListLimitProduct.length; index++) {
        //       if (OrichiQuantityLimitResult.ListLimitProduct[index].ProductID === product) {
        //         // ユーザー単位の購入制限の対象となった場合
        //         if (OrichiQuantityLimitResult.ListLimitProduct[index].MaxQuantity === OrichiQuantityLimitResult.ListLimitProduct[index].LifeTimeQuantity) return true;
        //         // 設定している上限数以上をカートインした場合
        //         if (OrichiQuantityLimitResult.ListLimitProduct[index].MaxQuantity <= OrichiQuantityLimitResult.ListLimitProduct[index].Quantity) {
        //           return (OrichiQuantityLimitResult.ListLimitProduct[index].MaxQuantity <= OrichiQuantityLimitResult.ListLimitProduct[index].Quantity);
        //         }
        //         // 設定している下限数以下がカートインされている場合
        //         if (OrichiQuantityLimitResult.ListLimitProduct[index].MinQuantity > OrichiQuantityLimitResult.ListLimitProduct[index].Quantity) {
        //           const minLimitText = document.querySelectorAll('.min-limit-text');
        //           if (minLimitText) {
        //             minLimitText.forEach((elem) => {
        //               const productId = elem.closest('.c-list__item').getAttribute('data-product');
        //               if (productId === String(OrichiQuantityLimitResult.ListLimitProduct[index].ProductID)) {
        //                 elem.textContent = `${OrichiQuantityLimitResult.ListLimitProduct[index].MinQuantity}点以上で購入可能です。`;
        //               }
        //             });
        //           }
        //         }
        //       }
        //     }
        //   }
        // }
        var t, e, r;
        return (
          (t = GoCart),
          (r = [
            {
              key: 'removeItemAnimation',
              value: function (t) {
                t.classList.add('is-invisible');
              },
            },
          ]),
          (e = [
            {
              key: 'init',
              value: function () {
                var t = this;
                this.fetchCart(), this.isDrawerMode && this.setDrawerDirection();
                let installmentForm = document.querySelector('form.installment');
                if (installmentForm) {
                  addEventListener(
                    'submit',
                    function (e) {
                      e.preventDefault();
                      var a = e.target.getAttribute('id');
                      t.addItemToCart(a);
                    },
                    false
                  );
                }
                document.addEventListener(
                  'click',
                  function (e) {
                    if (e.target.matches(t.defaults.addToCart)) {
                      e.preventDefault();
                      for (var r = e.target.parentNode; 'form' !== r.tagName.toLowerCase(); ) r = r.parentNode;
                      var a = r.getAttribute('id');
                      t.addItemToCart(a);
                    }
                  },
                  !1
                ),
                  this.cartTrigger.addEventListener('click', function (e) {
                    e.preventDefault();
                    t.isDrawerMode ? t.openCartDrawer() : t.openMiniCart(), t.openCartOverlay();
                  }),
                  this.cartOverlay.addEventListener('click', function () {
                    t.closeFailModal(),
                      t.closeCartModal(),
                      t.isDrawerMode ? t.closeCartDrawer() : t.closeMiniCart(),
                      t.closeCartOverlay();
                  }),
                  this.isDrawerMode &&
                    this.cartDrawerClose.addEventListener('click', function () {
                      t.closeCartDrawer(), t.closeCartOverlay();
                    }),
                  this.displayModal &&
                    this.cartModalClose.forEach(function (e) {
                      e.addEventListener('click', function () {
                        t.closeFailModal(),
                          t.closeCartModal(),
                          t.isDrawerMode ? t.closeCartDrawer() : t.closeMiniCart(),
                          t.closeCartOverlay();
                      });
                    });
              },
            },
            {
              key: 'fetchCart',
              value: function (t) {
                var e = this;
                window
                  .fetch('/cart.js', {
                    credentials: 'same-origin',
                    method: 'GET',
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (r) {
                    return e.fetchHandler(r, t);
                  })
                  // FIXME: iosでしか起きていないので違う原因かもしれないが暫定でエラー対応
                  .catch(function (t) {
                    throw new Error(t);
                  });
              },
            },
            {
              key: 'addItemToCart',
              value: function (t) {
                var e = this,
                  r = document.querySelector('#'.concat(t)),
                  a = f()(r, {hash: !0});
                // ノベルティ付与の対象商品がカートインされた場合、ノベルティをカートに追加
                if (window.novelty) {
                  // カートの中身をチェック
                  const cartItemIds = [];
                  Object.keys(e.cartDrawerContent.children).forEach(key => {
                    const cartItem = e.cartDrawerContent.children[key];
                    cartItemIds.push(cartItem.getAttribute('data-var'));
                  });
                  const productBasedRules = window.novelty.productBased || [];
                  const target = r.closest('.c-modal__content-buttonarea');
                  const targetId = target.getAttribute('id');
                  if (productBasedRules.length) {
                    productBasedRules.forEach(pRule => {
                      const associatedVariantIds = pRule.associatedVariantIds;
                      const giftVariantId = pRule.giftVariantId;
                      // ノベルティ付与の対象商品且つ、カート内にノベルティがない場合
                      if (associatedVariantIds.includes(targetId) && !cartItemIds.includes(giftVariantId)) {
                        a = {id: [a.id, giftVariantId]};
                      }
                    });
                  }
                }
                window
                  .fetch('/cart/add.js', {
                    method: 'POST',
                    credentials: 'include',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(a),
                  })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (t) {
                    return e.addItemToCartHandler(t);
                  })
                  .catch(function (t) {
                    throw (e.ajaxRequestFail(), new Error(t));
                  });
              },
            },
            {
              key: 'removeItem',
              value: function (t, variantId) {
                var e = this;
                const removeCartItem = async () => {
                  await window
                    .fetch('/cart/change.js', {
                      method: 'POST',
                      credentials: 'same-origin',
                      body: JSON.stringify({quantity: 0, line: t}),
                      headers: {'Content-Type': 'application/json'},
                    })
                    .then(function (t) {
                      return t.json();
                    })
                    .then(function () {
                      return e.fetchCart();
                    })
                    .catch(function (t) {
                      throw (e.ajaxRequestFail(), new Error(t));
                    });

                  if (window.novelty) {
                    // カートの中身をチェック
                    const cartItemIds = [];
                    setTimeout(() => {
                      Object.keys(e.cartDrawerContent.children).forEach(key => {
                        const cartItem = e.cartDrawerContent.children[key];
                        cartItemIds.push(cartItem.getAttribute('data-var'));
                      });
                      const productBasedRules = window.novelty.productBased || [];
                      if (productBasedRules.length) {
                        productBasedRules.forEach(pRule => {
                          const associatedVariantIds = pRule.associatedVariantIds;
                          const eligibleProducts = associatedVariantIds.filter(i => cartItemIds.includes(i));
                          // カートの中にノベルティ付与対象商品がない場合は、ノベルティもカートから削除
                          if (associatedVariantIds.includes(variantId) && !eligibleProducts.length) {
                            e.removeNoveltyItem();
                          }
                        });
                      }
                    }, 1000);
                  }
                };
                removeCartItem();
              },
            },
            {
              key: 'removeNoveltyItem',
              value: function () {
                const cart = this;
                let noveltyId;
                if (window.novelty) {
                  // カートの中身をチェック
                  const cartItemIds = [];
                  Object.keys(cart.cartDrawerContent.children).forEach(key => {
                    const cartItem = cart.cartDrawerContent.children[key];
                    cartItemIds.push(cartItem.getAttribute('data-var'));
                  });
                  // ノベルティをカートから削除
                  const productBasedRules = window.novelty.productBased || [];
                  if (productBasedRules.length) {
                    productBasedRules.forEach(pRule => {
                      const giftVariantId = pRule.giftVariantId;
                      if (cartItemIds.includes(giftVariantId)) {
                        noveltyId = giftVariantId;

                        window
                          .fetch('/cart/change.js', {
                            method: 'POST',
                            credentials: 'same-origin',
                            body: JSON.stringify({quantity: 0, id: noveltyId}),
                            headers: {'Content-Type': 'application/json'},
                          })
                          .then(function (t) {
                            return t.json();
                          })
                          .then(function () {
                            return cart.fetchCart();
                          })
                          .catch(function (t) {
                            throw (cart.ajaxRequestFail(), new Error(t));
                          });
                      }
                    });
                  }
                }
              },
            },
            {
              key: 'changeItemQuantity',
              value: function (t, e, variantId) {
                const cart = this;
                const changecartItemQuantity = async () => {
                  await window
                    .fetch('/cart/change.js', {
                      method: 'POST',
                      credentials: 'same-origin',
                      body: JSON.stringify({quantity: e, line: t}),
                      headers: {'Content-Type': 'application/json'},
                    })
                    .then(function (t) {
                      return t.json();
                    })
                    .then(function () {
                      return cart.fetchCart();
                    })
                    .catch(function (t) {
                      throw (cart.ajaxRequestFail(), new Error(t));
                    });

                  if (window.novelty) {
                    // カートの中身をチェック
                    const cartItemIds = [];
                    setTimeout(() => {
                      Object.keys(cart.cartDrawerContent.children).forEach(key => {
                        const cartItem = cart.cartDrawerContent.children[key];
                        cartItemIds.push(cartItem.getAttribute('data-var'));
                      });
                      const productBasedRules = window.novelty.productBased || [];
                      if (productBasedRules.length) {
                        productBasedRules.forEach(pRule => {
                          const associatedVariantIds = pRule.associatedVariantIds;
                          const eligibleProducts = associatedVariantIds.filter(i => cartItemIds.includes(i));
                          // カートの中にノベルティ付与対象商品がない場合は、ノベルティもカートから削除
                          if (associatedVariantIds.includes(variantId) && !eligibleProducts.length) {
                            cart.removeNoveltyItem();
                          }
                        });
                      }
                    }, 1000);
                  }
                };
                changecartItemQuantity();
              },
            },
            {
              key: 'cartItemCount',
              value: function (t) {
                this.cartCount.innerHTML = '';
                if (t.item_count) {
                  this.cartCount.innerHTML = t.item_count;
                }
              },
            },
            {
              key: 'fetchAndOpenCart',
              value: function () {
                var t = this;
                this.fetchCart(function () {
                  t.isDrawerMode ? t.openCartDrawer() : t.openMiniCart(), t.openCartOverlay();
                });
              },
            },
            {
              key: 'fetchAndOpenModal',
              value: function (t) {
                var e = this;
                this.fetchCart(function () {
                  e.renderCartModal(t), e.openCartModal(), e.openCartOverlay();
                });
              },
            },
            {
              key: 'fetchHandler',
              value: function (t, e) {
                this.cartItemCount(t),
                  this.isDrawerMode
                    ? 0 === t.item_count
                      ? (this.renderBlankCartDrawer(), this.cartDrawerFooter.classList.add('is-invisible'))
                      : (this.renderDrawerCart(t),
                        this.cartDrawerFooter.classList.remove('is-invisible'),
                        'function' === typeof e && e(t))
                    : 0 === t.item_count
                      ? (this.renderBlankMiniCart(), this.cartMiniCartFooter.classList.add('is-invisible'))
                      : (this.renderMiniCart(t),
                        this.cartMiniCartFooter.classList.remove('is-invisible'),
                        'function' === typeof e && e(t));
              },
            },
            {
              key: 'addItemToCartHandler',
              value: function (t) {
                return this.displayModal ? this.fetchAndOpenModal(t) : this.fetchAndOpenCart();
              },
            },
            {
              key: 'ajaxRequestFail',
              value: function () {
                this.openFailModal(), this.openCartOverlay();
              },
            },
            {
              key: 'renderCartModal',
              value: function (t) {
                this.clearCartModal();
                var e = t.variant_title;
                e = null === e ? '' : '('.concat(e, ')');
                var r =
                  '\n        <div class="go-cart-modal-item">\n            <div class="go-cart-item__image" style="background-image: url('
                    .concat(
                      t.image,
                      ');"></div>\n            <div class="go-cart-item__info">\n                <a href="'
                    )
                    .concat(t.url, '" class="go-cart-item__title">')
                    .concat(t.product_title, ' ')
                    .concat(e, '</a> ');
                this.cartModalContent.innerHTML += r;
              },
            },
            {
              key: 'validatePurchaseLimit',
              value: function () {
                const storefrontApiPath = '/api/2025-07/graphql.json';

                // GraphQL API呼び出し共通関数
                const fetchMetafields = async queries => {
                  try {
                    const response = await fetch(storefrontApiPath, {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/graphql',
                        'X-Shopify-Storefront-Access-Token': storefrontApiToken,
                      },
                      body: queries,
                    });
                    const data = await response.json();
                    return data.data;
                  } catch (error) {
                    console.error('Metafield fetch error:', error);
                    return null;
                  }
                };

                // 会員制限メタフィールド取得
                const fetchRequiredPlan = async productId => {
                  const query = `query { 
                      node(id: "gid://shopify/Product/${productId}") { 
                        ... on Product { 
                          metafields(identifiers: [
                            {namespace: "custom", key: "required_plan"},
                            {namespace: "custom", key: "allowed_plans"},
                            {namespace: "custom", key: "instyle_plan_allowed"}
                          ]) {
                            namespace 
                            key
                            value
                          } 
                        } 
                      }
                    }`;
                  const data = await fetchMetafields(query);
                  return data?.node?.metafields || null;
                };

                // 販売期間メタフィールド取得
                const fetchSalePeriod = async productId => {
                  const query = `query { 
                      node(id: "gid://shopify/Product/${productId}") { 
                        ... on Product { 
                          metafields(identifiers: [
                            {namespace: "custom", key: "start_time"},
                            {namespace: "custom", key: "end_time"}
                          ]) {
                            namespace 
                            key
                            value
                          } 
                        } 
                      }
                    }`;
                  const data = await fetchMetafields(query);
                  return data?.node?.metafields || null;
                };

                // 購入数制限メタフィールド取得
                const fetchPurchaseLimit = async (variantId, productId) => {
                  const query = `query {
                      variantNode: node(id: "gid://shopify/ProductVariant/${variantId}") {
                        ... on ProductVariant {
                          metafield(namespace: "variants", key: "limit") {
                            namespace
                            key
                            value
                          }
                        }
                      }
                      productNode: node(id: "gid://shopify/Product/${productId}") {
                        ... on Product {
                          metafield(namespace: "products", key: "limit") {
                            namespace
                            key
                            value
                          }
                        }
                      }
                    }`;
                  return await fetchMetafields(query);
                };

                // 会員制限バリデーション
                const validateMembershipPlan = async (item, customerPlan) => {
                  // 未ログインユーザーは会員制限をスキップ
                  if (customerPlan === null) return true;

                  const productId = item.getAttribute('data-product');
                  const metafields = await fetchRequiredPlan(productId);

                  const requiredPlan = metafields?.find(field => field && field.key === 'required_plan');
                  const allowedPlans = metafields?.find(field => field && field.key === 'allowed_plans');
                  const instylePlanAllowed = metafields?.find(
                    field => field && field.key === 'instyle_plan_allowed'
                  );
                  const normalizedCustomerPlan =
                    typeof customerPlan === 'string' ? customerPlan.trim() : customerPlan;

                  const lineItemErrorMessage = item.querySelector('.purchase-limit-error-text_line-item');
                  const quantityChanger = item.querySelector('.c-form-field__cart-select-wrapper');
                  const membershipPlanErrorMessage = 'この商品は現在のプランでは購入できません。\n';

                  const parseAllowedPlans = value => {
                    if (!value || typeof value !== 'string') return [];

                    const trimmed = value.trim();
                    if (!trimmed) return [];

                    try {
                      const parsed = JSON.parse(trimmed);
                      if (Array.isArray(parsed)) {
                        return parsed
                          .filter(plan => typeof plan === 'string')
                          .map(plan => plan.trim())
                          .filter(Boolean);
                      }
                      if (typeof parsed === 'string') {
                        const singlePlan = parsed.trim();
                        return singlePlan ? [singlePlan] : [];
                      }
                    } catch (_error) {
                      // JSON配列以外（例: GROUP,VIP）はCSVとして扱う
                    }

                    return trimmed
                      .split(',')
                      .map(plan => plan.trim())
                      .filter(Boolean);
                  };

                  const parseBooleanMetafield = value => {
                    if (typeof value === 'boolean') return value;
                    if (typeof value === 'string') {
                      const normalizedValue = value.trim().toLowerCase();
                      if (normalizedValue === 'true') return true;
                      if (normalizedValue === 'false') return false;
                    }
                    return null;
                  };

                  const instylePlanAllowedValue = parseBooleanMetafield(instylePlanAllowed?.value);

                  const failMembershipValidation = () => {
                    if (lineItemErrorMessage) {
                      lineItemErrorMessage.insertAdjacentText('beforeend', membershipPlanErrorMessage);
                    }
                    if (quantityChanger) {
                      quantityChanger.classList.add('c-form-field__cart-select-wrapper--error');
                    }
                    return false;
                  };

                  // 1. GROUP / VIP / REPRESENTATIVE の検証（厳密一致）
                  if (
                    normalizedCustomerPlan === 'GROUP' ||
                    normalizedCustomerPlan === 'VIP' ||
                    normalizedCustomerPlan === 'REPRESENTATIVE'
                  ) {
                    // INSTYLE系拒否設定: instyle_plan_allowedがfalseならallowed_plans判定を行わず拒否
                    if (instylePlanAllowedValue === false) {
                      return failMembershipValidation();
                    }

                    const allowedPlanValues = parseAllowedPlans(allowedPlans?.value);
                    // allowed_plans未設定（空配列）の場合は制限なしとして許可
                    if (allowedPlanValues.length === 0) {
                      return true;
                    }
                    if (!allowedPlanValues.includes(normalizedCustomerPlan)) {
                      return failMembershipValidation();
                    }
                    return true;
                  }

                  // 2. starプランの検証
                  // customerPlanが"1"〜"11"の文字列の場合
                  const customerPlanNum = parseInt(normalizedCustomerPlan);
                  if (customerPlanNum >= 1 && customerPlanNum <= 11) {
                    // instyle_plan_allowedがtrueの場合、starプランユーザーは購入不可
                    if (instylePlanAllowedValue === true) {
                      return failMembershipValidation();
                    }

                    const requiredPlanNum = requiredPlan?.value ? parseInt(requiredPlan.value) : null;
                    if (requiredPlanNum && customerPlanNum < requiredPlanNum) {
                      return failMembershipValidation();
                    }
                    // ユーザーのstarプラン数が十分な場合は購入可能
                    return true;
                  }

                  // その他の値の場合は購入不可
                  return false;
                };

                // 販売期間バリデーション
                const validateSalePeriod = async item => {
                  const productId = item.getAttribute('data-product');
                  const index = item.getAttribute('data-line');
                  const variantId = item.getAttribute('data-var');

                  const salePeriodFields = await fetchSalePeriod(productId);
                  const startTime = salePeriodFields?.find(field => field && field.key === 'start_time');
                  const endTime = salePeriodFields?.find(field => field && field.key === 'end_time');

                  const nowTime = new Date().getTime();
                  const startTimeDate = startTime?.value ? new Date(startTime.value).getTime() : null;
                  const endTimeDate = endTime?.value ? new Date(endTime.value).getTime() : null;

                  const cartErrorMessage = document.querySelector('.purchase-limit-error-text');
                  const lineItemErrorMessage = item.querySelector('.purchase-limit-error-text_line-item');
                  const quantityChanger = item.querySelector('.c-form-field__cart-select-wrapper');

                  // 販売開始前チェック
                  if (startTimeDate && nowTime < startTimeDate) {
                    if (lineItemErrorMessage) {
                      lineItemErrorMessage.innerHTML += `販売開始前です。\n`;
                    }
                    if (quantityChanger) {
                      quantityChanger.classList.add('c-form-field__cart-select-wrapper--error');
                    }
                    if (cartErrorMessage) {
                      cartErrorMessage.classList.remove('hidden');
                    }
                    this.removeItem(index, variantId);
                    return false;
                  }

                  // 販売終了後チェック
                  if (endTimeDate && nowTime > endTimeDate) {
                    if (lineItemErrorMessage) {
                      lineItemErrorMessage.innerHTML += `販売期間が終了しました。\n`;
                    }
                    if (quantityChanger) {
                      quantityChanger.classList.add('c-form-field__cart-select-wrapper--error');
                    }
                    if (cartErrorMessage) {
                      cartErrorMessage.classList.remove('hidden');
                    }
                    this.removeItem(index, variantId);
                    return false;
                  }

                  return true;
                };

                // 購入数制限バリデーション
                const validateQuantityLimit = async (item, allCartItems) => {
                  const variantId = item.getAttribute('data-var');
                  const productId = item.getAttribute('data-product');
                  const countInCart = parseInt(item.getAttribute('data-quantity'));

                  const purchaseLimitMetafields = await fetchPurchaseLimit(variantId, productId);
                  const variantLimit = purchaseLimitMetafields?.variantNode?.metafield;
                  const productLimit = purchaseLimitMetafields?.productNode?.metafield;

                  const errorMessage = item.querySelector('.quantity-limit-error-text');
                  const quantityChanger = item.querySelector('.c-form-field__cart-select-wrapper');

                  // エラーメッセージとスタイルをリセット
                  if (errorMessage) {
                    errorMessage.innerHTML = '';
                  }
                  if (quantityChanger) {
                    quantityChanger.classList.remove('c-form-field__cart-select-wrapper--error');
                  }

                  // エラーがあるかどうかをチェック
                  let hasError = false;

                  // バリアント単位の購入制限チェック
                  if (variantLimit) {
                    const variantLimitValue = parseInt(variantLimit.value);
                    if (countInCart > variantLimitValue) {
                      if (errorMessage) {
                        errorMessage.innerHTML += `この商品は${variantLimitValue}点までの購入になります。\n`;
                      }
                      if (quantityChanger) {
                        quantityChanger.classList.add('c-form-field__cart-select-wrapper--error');
                      }
                      hasError = true;
                    }
                  }

                  // 商品単位の購入制限チェック
                  if (productLimit) {
                    let totalQuantity = 0;
                    const cart = document.querySelector('.l-cart__contents-inner');
                    const limitedProducts = cart.querySelectorAll(`[data-product="${productId}"]`);

                    limitedProducts.forEach(cartItem => {
                      totalQuantity += Number(cartItem.getAttribute('data-quantity'));
                    });

                    const productLimitValue = parseInt(productLimit.value);
                    if (totalQuantity > productLimitValue) {
                      if (errorMessage) {
                        errorMessage.innerHTML += `この商品はカート内で合計${productLimitValue}点までの購入になります。\n`;
                      }
                      if (quantityChanger) {
                        quantityChanger.classList.add('c-form-field__cart-select-wrapper--error');
                      }
                      hasError = true;
                    }
                  }

                  return !hasError;
                };

                // メインバリデーション処理
                const processValidation = async cartItems => {
                  const checkoutButton = document.querySelector(
                    '.l-cart__purchase-button-wrap.js-go-cart-drawer-footer a'
                  );

                  // UI初期化
                  if (checkoutButton) {
                    checkoutButton.classList.add('c-button__disabled');
                  }
                  document.querySelectorAll('.go-cart-item__quantity-button').forEach(button => {
                    button.style.pointerEvents = 'none';
                  });

                  let checkoutEnabled = true;
                  // ログインユーザーでメタフィールドが空の場合は1starプラン（デフォルト）を適用
                  const isLoggedIn = customer !== '';
                  let customerPlanValue = null;
                  if (isLoggedIn) {
                    // プラン値はtrimのみ行い、空の場合は1starプラン（デフォルト）
                    if (customerPlan && customerPlan.trim() !== '') {
                      customerPlanValue = customerPlan.trim();
                    } else {
                      customerPlanValue = '1';
                    }
                  }

                  // 各アイテムのバリデーション実行
                  for (const item of cartItems) {
                    const membershipValid = await validateMembershipPlan(item, customerPlanValue);
                    const periodValid = await validateSalePeriod(item);
                    const quantityValid = await validateQuantityLimit(item, cartItems);

                    if (!membershipValid || !periodValid || !quantityValid) {
                      checkoutEnabled = false;
                    }
                  }

                  // UI更新
                  if (checkoutButton) {
                    checkoutEnabled
                      ? checkoutButton.classList.remove('c-button__disabled')
                      : checkoutButton.classList.add('c-button__disabled');
                  }

                  document.querySelectorAll('.go-cart-item__quantity-button').forEach(button => {
                    button.style.pointerEvents = 'auto';
                  });

                  // エラーメッセージクリア用イベント
                  document.querySelectorAll('.c-modal__container').forEach(modal => {
                    modal.addEventListener('click', () => {
                      const errorMessage = document.querySelector('.purchase-limit-error-text');
                      if (errorMessage) {
                        errorMessage.classList.add('hidden');
                      }
                    });
                  });
                };

                // バリデーション実行
                const cartItems = document.querySelectorAll('.c-list__item');
                processValidation(cartItems);
              },
            },
            {
              key: 'renderDrawerCart',
              value: function (t) {
                var e = this;
                this.clearCartDrawer(),
                  t.items.forEach(function (t, r) {
                    var variantId = t.variant_id;
                    var productId = t.product_id;
                    var productQty = t.quantity;
                    var sku = t.sku;
                    var color = t.variant_options.length ? t.variant_options[0] : '';
                    var size = t.variant_options.length ? t.variant_options[1] : '';
                    var formId = 'add-to-cart-' + variantId;
                    var btnId = 'not-add-to-cart-' + variantId;
                    var a = t.variant_title.replace(' /', ', ');
                    var formatPrice = formatMoney(t.line_price / t.quantity).slice(0, -3);
                    var alt = t.featured_image.alt;
                    var image = t.featured_image.url;
                    // 画像がない場合はno-imageのurlを代入（liquidタグで取得する必要があるので変数の定義はgocart.liquidでおこなっている）
                    if (image === null) {
                      var image = goCartNoImage;
                    }
                    let elemFinder = document.getElementById(formId);
                    if (elemFinder) {
                      document.getElementById(formId).classList.remove('limit-variant-btn');
                      document.getElementById(btnId).classList.remove('limit-variant-btn');
                    }
                    const modalContentList = document.querySelector('.c-modal__content-list');
                    if (modalContentList) {
                      const cartProductId = modalContentList.getAttribute('cart-product-id');
                      if (cartProductId !== String(productId)) {
                        modalContentList.classList.remove('limit-product-list');
                      }
                    }
                    const minLimitText = document.querySelectorAll('.min-limit-text');
                    if (minLimitText) {
                      minLimitText.forEach(elem => {
                        const dataProductId = elem.closest('.c-list__item').getAttribute('data-product');
                        if (dataProductId === String(productId)) {
                          elem.textContent = '';
                        }
                      });
                    }
                    var o = '<li class="c-list__item" data-product="'
                      .concat(productId, '" data-quantity="')
                      .concat(productQty, '" data-sku="')
                      .concat(sku, '" data-color="')
                      .concat(color, '" data-size="')
                      .concat(size, '" data-price="')
                      .concat(formatPrice, '" data-var="')
                      .concat(variantId, '" data-line="')
                      .concat(
                        Number(r + 1),
                        '"><div class="l-line-item"><div class="l-line-item__inner"><a class="l-line-item__figure" href="'
                      )
                      .concat(t.url, '"><img class="l-line-item__image" src="')
                      .concat(image, '" alt="')
                      .concat(
                        alt,
                        '"/></a><div class="l-line-item__body"><div class="l-line-item__body-inner l-line-item__body-inner--cart"><div class="l-line-item__name l-line-item__name--cart">'
                      )
                      .concat(
                        t.product_title,
                        '</div><ul class="l-line-item__option-list"><li class="l-line-item__option-list-item">'
                      )
                      .concat(a, '</li></ul><div class="l-line-item__price l-line-item__price--cart">')
                      .concat(
                        formatPrice,
                        '</div><div class="l-line-item__quantity-wrap"><div class="c-form-field__cart-select-wrapper go-cart-item__quantity-wrapper"><span class="go-cart-item__quantity-button js-go-cart-quantity-minus quantity-minus-btn"><span class="icon">-</span></span><input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="'
                      )
                      .concat(
                        t.quantity,
                        '" disabled><span class="go-cart-item__quantity-button js-go-cart-quantity-plus quantity-plus-btn"><span class="icon">+</span></span></div><button class="l-line-item__delete '
                      )
                      .concat(e.removeFromCartNoDot, '" type="button">')
                      .concat(
                        e.labelRemove,
                        '</button></div><p class="quantity-limit-error-text"></p><p class="purchase-limit-error-text_line-item"></p></div></div></div></div><p class="purchase-limit-text">商品の購入可能な上限数に達しました。</p><p class="min-limit-text"></p></li>'
                      );

                    // }
                    e.cartDrawerContent.innerHTML += o;

                    // ノベルティ用のclass付与
                    if (window.novelty) {
                      const productBasedRules = window.novelty.productBased || [];
                      if (productBasedRules.length) {
                        productBasedRules.forEach(pRule => {
                          const giftVariantId = pRule.giftVariantId;
                          if (giftVariantId.includes(String(variantId))) {
                            const noveltyItem = document.querySelector(`[data-var="${variantId}"]`);
                            noveltyItem.classList.add('novelty-item');
                          }
                        });
                      }
                    }
                  }),
                  (this.cartDrawerSubTotal.innerHTML = formatMoney(t.total_price, this.moneyFormat).slice(0, -3)),
                  this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible'),
                  // カートアイテム削除の処理
                  document.querySelectorAll(this.removeFromCart).forEach(function (t) {
                    t.addEventListener('click', function () {
                      GoCart.removeItemAnimation(t.parentNode);
                      var r =
                        t.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                      const variantId = t.closest('.c-list__item').getAttribute('data-var');
                      const id = t.closest('.c-list__item').getAttribute('data-sku');
                      const price = t.closest('.c-list__item').getAttribute('data-price');
                      const quantity = t.closest('.c-list__item').getAttribute('data-quantity');
                      const color = t.closest('.c-list__item').getAttribute('data-color');
                      const size = t.closest('.c-list__item').getAttribute('data-size');
                      e.removeItem(r, variantId);
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({
                        event: 'remove_from_cart',
                        products: [
                          {
                            id,
                            price,
                            quantity,
                            option: {
                              size,
                              color,
                            },
                          },
                        ],
                      });
                      const modalContentList = document.querySelector('.c-modal__content-list');
                      if (modalContentList) {
                        modalContentList.classList.remove('limit-product-list');
                        // 購入可能
                        const enableBtn = document.getElementById(`add-to-cart-${variantId}`);
                        // 購入不可
                        const disableBtn = document.getElementById(`not-add-to-cart-${variantId}`);
                        // 商品削除後、購入可能ならボタンを活性化する
                        if (enableBtn) {
                          enableBtn.classList.remove('limit-variant-btn');
                          disableBtn.classList.remove('limit-variant-btn');
                        }
                      }
                    });
                  }),
                  document.querySelectorAll(this.itemQuantityPlus).forEach(function (t) {
                    t.addEventListener('click', function () {
                      // add one more item
                      var r =
                          t.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
                            'data-line'
                          ),
                        a = Number(t.parentNode.querySelector(e.itemQuantity).value) + 1;
                      const checkoutButton = document.querySelector(
                        '.l-cart__purchase-button-wrap.js-go-cart-drawer-footer a'
                      );
                      checkoutButton.classList.add('c-button__disabled');
                      e.changeItemQuantity(r, a);
                    });
                  }),
                  document.querySelectorAll(this.itemQuantityMinus).forEach(function (t) {
                    t.addEventListener('click', function () {
                      var r =
                          t.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
                            'data-line'
                          ),
                        a = Number(t.parentNode.querySelector(e.itemQuantity).value) - 1;
                      const variantId = t.closest('.c-list__item').getAttribute('data-var');
                      e.changeItemQuantity(r, a, variantId),
                        0 === Number(t.parentNode.querySelector(e.itemQuantity).value - 1) &&
                          GoCart.removeItemAnimation(t.parentNode.parentNode.parentNode.parentNode);
                      const modalContentList = document.querySelector('.c-modal__content-list');
                      if (modalContentList) {
                        modalContentList.classList.remove('limit-product-list');
                        // // 商品id
                        const itemDataId = t.closest('.c-list__item').getAttribute('data-var');
                        // 購入可能
                        const enableBtn = document.getElementById(`add-to-cart-${itemDataId}`);
                        // 購入不可
                        const disableBtn = document.getElementById(`not-add-to-cart-${itemDataId}`);
                        // 商品削除後、購入可能ならボタンを活性化する
                        if (enableBtn) {
                          enableBtn.classList.remove('limit-variant-btn');
                          disableBtn.classList.remove('limit-variant-btn');
                        }
                      }
                    });
                  });
                this.validatePurchaseLimit();
              },
              // end cart
            },
            {
              key: 'renderBlankCartDrawer',
              value: function () {
                this.cartDrawerSubTotal.parentNode.classList.add('is-invisible'),
                  this.clearCartDrawer(),
                  (this.cartDrawerContent.innerHTML = '<div class="c-page-title__sub-title go-cart__empty">'.concat(
                    this.labelCartIsEmpty,
                    '</div>'
                  ));
              },
            },
            {
              key: 'renderBlankMiniCart',
              value: function () {
                this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible'),
                  this.clearMiniCart(),
                  (this.cartMiniCartContent.innerHTML = '<div class="c-page-title__sub-title go-cart__empty">'.concat(
                    this.labelCartIsEmpty,
                    '</div>'
                  ));
              },
            },
            {
              key: 'clearCartDrawer',
              value: function () {
                this.cartDrawerContent.innerHTML = '';
              },
            },
            {
              key: 'clearMiniCart',
              value: function () {
                this.cartMiniCartContent.innerHTML = '';
              },
            },
            {
              key: 'clearCartModal',
              value: function () {
                this.cartModalContent.innerHTML = '';
              },
            },
            {
              key: 'openCartDrawer',
              value: function () {
                this.cartDrawer.classList.add('is-open');
                document.body.style.overflow = 'hidden';
                document.body.scroll = 'no';
              },
            },
            {
              key: 'closeCartDrawer',
              value: function () {
                this.cartDrawer.classList.remove('is-open');
                document.body.style.overflow = 'auto';
                document.body.scroll = 'yes';
              },
            },
            {
              key: 'openMiniCart',
              value: function () {
                this.cartMiniCart.classList.add('is-open');
              },
            },
            {
              key: 'closeMiniCart',
              value: function () {
                this.cartMiniCart.classList.remove('is-open');
              },
            },
            {
              key: 'openFailModal',
              value: function () {
                this.cartModalFail.classList.add('is-open');
              },
            },
            {
              key: 'closeFailModal',
              value: function () {
                this.cartModalFail.classList.remove('is-open');
              },
            },
            {
              key: 'openCartModal',
              value: function () {
                this.cartModal.classList.add('is-open');
              },
            },
            {
              key: 'closeCartModal',
              value: function () {
                this.cartModal.classList.remove('is-open');
              },
            },
            {
              key: 'openCartOverlay',
              value: function () {
                this.cartOverlay.classList.add('is-open');
              },
            },
            {
              key: 'closeCartOverlay',
              value: function () {
                this.cartOverlay.classList.remove('is-open');
              },
            },
            {
              key: 'setDrawerDirection',
              value: function () {
                this.cartDrawer.classList.add('go-cart__drawer--'.concat(this.drawerDirection));
              },
            },
            {
              key: 'isDrawerMode',
              get: function () {
                return 'drawer' === this.cartMode;
              },
            },
          ]) && _defineProperties(t.prototype, e),
          r && _defineProperties(t, r),
          GoCart
        );
      })();
      e.default = h;
    },
  ]).default;
});
